export default __webpack_public_path__ + "static/media/fasttrack.591acad5.png";